import { api } from "./client.js";
import type { Rule } from "@cas/shared";

export interface TestRuleResult {
  matched: boolean;
  ruleName: string;
  sample: { from: string; subject: string; bodyPreview: string };
}

export const testRuleApi = {
  run: (rule: Rule, email: { from: string; subject: string; body: string }) =>
    api.post<TestRuleResult>("manage/test-rule", { rule, email }),
};
